import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { List, Grid } from 'semantic-ui-react';
import { setError } from '../../../../redux/actions/actionsCallAPI';
import { getErrorList } from '../../../../redux/selectors/selectorCallAPI';
// import { iconCloseModalError, iconLogoModalError } from '../../config'
import ActionModal from './actionModal';
import { translate } from 'react-switch-lang';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ErrorModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { errorList, t } = this.props;

        return (
            <React.Fragment>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />

                {errorList.length > 0 &&
                    toast.error(
                        <React.Fragment>
                            <p style={{ fontWeight: 'bold', color: 'white', fontSize: '1em' }}>{t('common.somethingWrong')}</p>
                            {errorList.map((e, i) => {
                                const { message, path, code } = e;
                                const data = { statusText: message, statusCode: path, code: code };
                                return <ItemErrorObj key={i} data={data} />;
                            })}
                        </React.Fragment>,
                        {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            onClose: () => this.props.setError(null, null, true),
                        },
                    )}
                {/* <ActionModal  {...{
					typeAction: 'danger',
					type: 'danger',
					header: t('common.somethingWrong'),
					detail: <Grid>
						<Grid.Row>
							<Grid.Column>
								<List divided verticalAlign='middle'>
									{
										errorList.map((e, i) => {
											const { message, path, code } = e
											const data = { statusText: message, statusCode: path, code: code }
											return <ItemErrorObj key={i} data={data} />

										})
									}
								</List>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				}} open={errorList.length > 0} close={() => this.props.setError(null, null, true)} cancelButtonName="OK" /> */}
            </React.Fragment>
        );
    }
}

const ItemErrorObj = (props) => {
    const { data } = props;

    return (
        <List.Item className="itemError">
            <List.Content>
                {data.code && <p style={{ color: 'white', fontSize: '0.9em' }}>{data.code}</p>}
                <p style={{ color: 'white', fontSize: '0.9em' }} className="detailError header">
                    {data.statusText}
                </p>
            </List.Content>
        </List.Item>
    );
};

export default compose(
    withRouter,
    translate,
    connect(
        (state, props) => ({
            errorList: getErrorList(state),
        }),
        (dispatch, { history }) => ({
            setError(errorList, newError, isShow) {
                dispatch(setError(errorList, newError, isShow));
            },
        }),
    ),
    lifecycle({}),
)(ErrorModal);



// WEBPACK FOOTER //
// ./src/app/components/features/share/modal/errorModal.js